import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
class TDCPhotoSwipe {
    constructor() {
        this.lightbox = null;
        this.initialize();
    }
    getLargestSrcFromSrcset(srcset) {
        if (!srcset)
            return null;
        try {
            const candidates = srcset
                .split(",")
                .map((c) => c.trim())
                .map((c) => {
                const [url, descriptor] = c.split(/\s+/);
                const width = descriptor && descriptor.endsWith("w")
                    ? parseInt(descriptor.slice(0, -1), 10)
                    : 0;
                return { url, width };
            })
                .filter((c) => !!c.url);
            if (candidates.length === 0)
                return null;
            candidates.sort((a, b) => b.width - a.width);
            return candidates[0].url;
        }
        catch (_a) {
            return null;
        }
    }
    extractDimensionsFromUrl(url) {
        const match = url.match(/-(\d+)x(\d+)(?=\.[a-zA-Z]{3,4}(?:\?|$))/);
        if (match) {
            const w = parseInt(match[1], 10);
            const h = parseInt(match[2], 10);
            if (Number.isFinite(w) && Number.isFinite(h)) {
                return { w, h };
            }
        }
        return {};
    }
    initialize() {
        try {
            const galleries = document.querySelectorAll(".wp-block-gallery");
            if (galleries.length === 0) {
                console.warn("No WordPress galleries found on the page");
                return;
            }
            // Pre-annotate images so PhotoSwipe knows large src and dimensions upfront (helps Chrome sizing)
            document
                .querySelectorAll(".wp-block-image a img, .wp-block-image > img")
                .forEach((img) => {
                try {
                    const srcset = img.getAttribute("srcset");
                    const largest = this.getLargestSrcFromSrcset(srcset) ||
                        img.getAttribute("src") ||
                        "";
                    if (largest) {
                        img.setAttribute("data-pswp-src", largest);
                    }
                    // Prefer width/height attributes; fallback to natural sizes if available
                    let w = parseInt(img.getAttribute("width") || "0", 10);
                    let h = parseInt(img.getAttribute("height") || "0", 10);
                    if ((!w || !h) && img.naturalWidth && img.naturalHeight) {
                        w = img.naturalWidth;
                        h = img.naturalHeight;
                    }
                    if (w && h) {
                        img.setAttribute("data-pswp-width", String(w));
                        img.setAttribute("data-pswp-height", String(h));
                    }
                }
                catch (_a) { }
            });
            this.lightbox = new PhotoSwipeLightbox({
                gallery: ".wp-block-gallery",
                children: ".wp-block-image a img, .wp-block-image > img",
                pswpModule: PhotoSwipe,
                arrowKeys: true,
                allowPanToNext: true,
                arrowPrev: true,
                arrowNext: true,
                bgOpacity: 0.85,
                showHideOpacity: true,
                padding: { top: 20, bottom: 20, left: 20, right: 20 },
                imageClickAction: "zoom",
                tapAction: "zoom",
                clickToCloseNonZoomable: false,
            });
            this.lightbox.on("itemData", (e) => {
                var _a;
                const img = (_a = e === null || e === void 0 ? void 0 : e.itemData) === null || _a === void 0 ? void 0 : _a.element;
                if (!img)
                    return;
                // Prefer pre-annotated attributes when present
                const dataSrc = img.getAttribute("data-pswp-src");
                const chosenSrc = dataSrc ||
                    this.getLargestSrcFromSrcset(img.getAttribute("srcset")) ||
                    img.getAttribute("src");
                if (chosenSrc) {
                    e.itemData.src = chosenSrc;
                }
                const attrW = parseInt(img.getAttribute("data-pswp-width") ||
                    img.getAttribute("width") ||
                    "0", 10);
                const attrH = parseInt(img.getAttribute("data-pswp-height") ||
                    img.getAttribute("height") ||
                    "0", 10);
                if (attrW > 0 && attrH > 0) {
                    e.itemData.w = attrW;
                    e.itemData.h = attrH;
                }
                else if (img.naturalWidth && img.naturalHeight) {
                    e.itemData.w = img.naturalWidth;
                    e.itemData.h = img.naturalHeight;
                }
                else {
                    // Last resort: try to parse from URL (e.g., -650x444)
                    if (chosenSrc) {
                        const fromUrl = this.extractDimensionsFromUrl(chosenSrc);
                        if (fromUrl.w && fromUrl.h) {
                            e.itemData.w = fromUrl.w;
                            e.itemData.h = fromUrl.h;
                        }
                    }
                }
                if (!e.itemData.thumbEl) {
                    e.itemData.thumbEl = img;
                }
            });
            this.lightbox.on("beforeOpen", () => {
                document.body.style.overflow = "hidden";
            });
            this.lightbox.on("close", () => {
                document.body.style.overflow = "";
            });
            this.lightbox.on("firstUpdate", () => { });
            this.lightbox.init();
        }
        catch (error) {
            console.error("Failed to initialize PhotoSwipe:", error);
        }
    }
    destroy() {
        if (this.lightbox) {
            this.lightbox.destroy();
            this.lightbox = null;
        }
    }
}
export default TDCPhotoSwipe;
//# sourceMappingURL=lightbox.js.map